import { observer } from "mobx-react-lite" 

export interface ManualClPageLayoutProps {
  children: React.ReactNode
  sidebar?: React.ReactNode
}

/**
 * Manual CL Page Layout
 * Provides consistent two-column layout for all manual CL pages
 *
 * Pattern:
 * - Mobile/Tablet (< lg): Stacks vertically
 * - Desktop (>= lg, < xl): Equal two columns
 * - Desktop (>= xl): Fixed-width left column (max 672px for max-w-2xl), flexible right column
 *
 * Used by:
 * - Create Pool page (with pool list sidebar)
 * - Create Position page (with pool info sidebar)
 * - Increase/Decrease Position pages (with position info sidebar)
 */
export const ManualClPageLayout = observer(({ children, sidebar }: ManualClPageLayoutProps) => {
  return (
    <div className="grid w-full grid-cols-1 gap-4 text-t100 xl:grid-cols-[minmax(auto,672px)_1fr]">
      <div className="flex w-full min-w-[320px] max-w-2xl flex-col gap-4">{children}</div>
      {sidebar && <div className="flex max-w-2xl flex-col gap-4">{sidebar}</div>}
    </div>
  )
})
